module.exports = __webpack_public_path__ + "img/img-pattern.888bf02c.png";